import { ITheme } from "@swiggy-private/dls-web-common/dist/components/types.internal";
import styled from "styled-components";

interface IOneTapCtaStyles {
    isCartV2?: boolean;
    isBlackPlan: boolean;
    isOneTapAddCta: boolean;
}

const cartV1 = {
    ctaWidth: "80px",
    ctaHeight: "32px",
};

const cartV2 = {
    ctaWidth: "64px",
    ctaHeight: "28px",
};

const getBorderColor = (theme: ITheme, isBlackPlan: boolean, isOneTapAddCta: boolean) => {
    if (isOneTapAddCta && isBlackPlan) {
        return "#B89F88";
    }
    return theme.colors[theme.colorMode].border_Secondary;
};

export const PlanPurchaseOneTapCTA = styled.div<IOneTapCtaStyles>(
    ({ theme, isCartV2, isBlackPlan = false, isOneTapAddCta = false }) => ({
        display: "flex",
        justifyContent: "center",
        alignItems: "center",
        marginLeft: theme.spacing.xSmall,
        width: isCartV2 ? cartV2.ctaWidth : cartV1.ctaWidth,
        height: isCartV2 ? cartV2.ctaHeight : cartV1.ctaHeight,
        borderRadius: theme.cornerRadius.xSmall,
        border: `1px solid ${getBorderColor(theme, isBlackPlan, isOneTapAddCta)}`,
        background: theme.colors[theme.colorMode].background_Primary,
        ...(isCartV2 && {
            marginRight: `calc(${theme.spacing.xxSmall} * -1)`,
            alignSelf: "center",
        }),
    }),
);
